/* global NDEFReader */

import React, { useState } from 'react';
import axios from 'axios';
import { useDispatch } from 'react-redux';
import { setToken } from '../features/auth/authSlice';
import { useNavigate } from 'react-router-dom';
import './Login.css';
import Logo from '../assets/gorion.png';
import API_BASE_URL from '../config';

const Login = () => {
  const [activeTab, setActiveTab] = useState('password');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false); // ⬅️ NUEVO
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await axios.post(`${API_BASE_URL}auth/login`, { email, password });
      const { token } = response.data;

      dispatch(setToken(token));
      navigate('/inicio');
    } catch (error) {
      console.error('Error en el inicio de sesión:', error);
      alert('Credenciales inválidas');
    } finally {
      setLoading(false);
    }
  };

  const handleNFCLogin = async () => {
    setLoading(true);
    try {
      if (!('NDEFReader' in window)) {
        alert('Tu navegador no soporta NFC');
        return;
      }

      const ndef = new NDEFReader();
      await ndef.scan();

      ndef.onreading = async (event) => {
        const { serialNumber } = event;
        const response = await axios.post(`${API_BASE_URL}auth/login-nfc`, { uid: serialNumber });
        const { token } = response.data;

        dispatch(setToken(token));
        navigate('/inicio');
      };
    } catch (err) {
      console.error('Error con NFC:', err.message);
      alert('Error al leer NFC');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-wrapper">
      <div className="login-card fancy-shadow">
        <img src={Logo} alt="ORION Logo" className="logo-img" />
        <div className="tab-selector">
          <button
            className={activeTab === 'password' ? 'tab active' : 'tab'}
            onClick={() => setActiveTab('password')}
          >
            Contraseña
          </button>
          <button
            className={activeTab === 'nfc' ? 'tab active' : 'tab'}
            onClick={() => setActiveTab('nfc')}
          >
            NFC
          </button>
        </div>

        {loading ? (
          <div className="loader-wrapper">
            <div className="spinner"></div>
            <p>Iniciando sesión...</p>
          </div>
        ) : activeTab === 'password' ? (
          <form onSubmit={handleLogin} className="login-form">
            <label>Email</label>
            <input
              type="email"
              placeholder="ejemplo@correo.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />

            <label>Contraseña</label>
            <input
              type="password"
              placeholder="********"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />

            <button type="submit" className="btn primary">
              Iniciar Sesión
            </button>
          </form>
        ) : (
                    <form onSubmit={handleLogin} className="login-form">
            <label>No. Colaborador</label>
            <input
              type="number"
              placeholder="Ej. 1842"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />

            <label>Contraseña</label>
            <input
              type="password"
              placeholder="********"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />

            <button type="submit" className="btn primary">
              Iniciar Sesión
            </button>
          </form>

        )}
      </div>
    </div>
  );
};

export default Login;
